import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
  submitting: {},
};

export default function operacaovazaonaoautorizada(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaovazaonaoautorizada/DELETE_OPERACAOVAZAONAOAUTORIZADA_CLIENTE':
      case '@operacaovazaonaoautorizada/FIND_OPERACAOVAZAONAOAUTORIZADA':
      case '@operacaovazaonaoautorizada/UPDATE_OPERACAOVAZAONAOAUTORIZADA':
      case '@operacaovazaonaoautorizada/DELETE_OPERACAOVAZAONAOAUTORIZADA':
      case '@operacaovazaonaoautorizada/STORE_OPERACAOVAZAONAOAUTORIZADA':
      case '@operacaovazaonaoautorizada/OPERACAOVAZOESNAOAUTORIZADAS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaovazaonaoautorizada/SUCCESS_REMOVE':
      case '@operacaovazaonaoautorizada/SUCCESS_REMOVE_FORM':
      case '@operacaovazaonaoautorizada/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaovazaonaoautorizada/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaovazoesnaoautorizadas;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaovazaonaoautorizada/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaovazaonaoautorizada;
        break;
      }

      case '@operacaovazaonaoautorizada/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@operacaovazaonaoautorizada/SUBMITTING': {
        draft.submitting = action.payload.data;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
